import { BrowserRouter, Routes, Route } from "react-router-dom";

import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Transactions from "./pages/Transactions";
import Loans from "./pages/Loans";
import DPD from "./pages/DPD";
import UV from "./pages/UV";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/users" element={<Users />} />
          <Route path="/transactions" element={<Transactions />} />
          <Route path="/loans" element={<Loans />} />
          <Route path="/dpd" element={<DPD />} />
          <Route path="/uv" element={<UV />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
